import { updateusers } from "@/api/user";
import { getPermission } from "@/api/user";
function findMinEndTime(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return null;

  // 过滤掉无效时间（空字符串、null、undefined）
  const validItems = arr.filter(
    (item) => item.end_time && !isNaN(new Date(item.end_time).getTime())
  );

  if (validItems.length === 0) return null; // 全部都是空时间

  // 使用 reduce 找出最小时间项
  return validItems.reduce((minItem, currentItem) => {
    const minTime = new Date(minItem.end_time).getTime();
    const curTime = new Date(currentItem.end_time).getTime();
    return curTime < minTime ? currentItem : minItem;
  });
}
/**
 * 计算距离到期时间还有几天，并判断是否过期
 * @param {string|Date} endTime - 到期时间（字符串或 Date 对象）
 * @returns {{ daysLeft: number, expired: boolean }}
 */
function getExpireInfo(endTime) {
  if (!endTime) {
    return { daysLeft: 0, expired: true };
  }

  const end = new Date(endTime);
  if (isNaN(end.getTime())) {
    return { daysLeft: 0, expired: true };
  }

  const now = new Date();
  const diffMs = end.getTime() - now.getTime();

  // 根据时间差动态判断是否过期
  const expired = diffMs <= 0;

  // 计算相差的天数（可能为负）
  let diffDays = diffMs / (1000 * 60 * 60 * 24);

  // 如果未过期，天数至少为 1（还没过期但不到 24h）
  let daysLeft = 0;
  if (!expired) {
    daysLeft = diffDays < 1 ? 1 : Math.floor(diffDays);
  }

  return { daysLeft, expired };
}

const getDefaultState = () => {
  return {
    userInfo: null,
    clientId: null,
    carlist: null,
    DRIVER_ENUM: {
      EXAM_SUBJECT_1: [],
      EXAM_SUBJECT_4: [],
      EXAM_FULL_SCORE_REVIEW: [],
      EXAM_LICENSE_RESTORE: [],
    },
    vip_daysLeft: 0, // 距离到期时间还有几天
    vip_expired: true, // 是否已过期
    permissionList: [],
    answeringRules: {
      rule_score: {},
      rule_switch: {},
    }, //当前答题规则
    isNw: window.nw ? true : false,
  };
};

const state = getDefaultState();

// 同步更新
const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
  },
  SET_CLIENT_ID(state, clientId) {
    state.clientId = clientId;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState()); // 重置 state
    localStorage.removeItem("userInfo"); // 清除缓存
  },
  SET_ANSWERING_RULES(state, answeringRules) {
    state.answeringRules = answeringRules;
  },
  SET_CARLIST(state, carlist) {
    state.carlist = carlist;
    const { driver } = carlist;
    const obj = {
      EXAM_SUBJECT_1: [],
      EXAM_SUBJECT_4: [],
      EXAM_FULL_SCORE_REVIEW: [],
      EXAM_LICENSE_RESTORE: [],
    };
    driver.forEach((item) => {
      item.car_subject.forEach((sub) => {
        if (obj[sub.page_code.split(":")[1]]) {
          obj[sub.page_code.split(":")[1]].push({
            ...sub,
            car_type_name: item.name,
            car_type_description: item.description,
            car_type_prefix_page_code: item.prefix_page_code,
          });
        }
      });
    });
    state.DRIVER_ENUM = obj;
  },
  SET_PERMISSION_LIST(state, list) {
    state.permissionList = list;
    const l = list.filter((item) => item.pay_state == 1);

    if (l.length) {
      // 处理已支付的权限
      const vip_end = findMinEndTime(l);
      if (vip_end) {
        const { daysLeft, expired } = getExpireInfo(vip_end.end_time);
        state.vip_daysLeft = daysLeft;
        state.vip_expired = expired;
      } else {
        state.vip_daysLeft = 0;
        state.vip_expired = true;
      }
    }
  },
};
// 异步更新
const actions = {
  setUserInfo({ commit }, userInfo) {
    let localUserInfo = localStorage.getItem("userInfo") || "{}";
    commit("SET_USER_INFO", Object.assign(JSON.parse(localUserInfo), userInfo));
  },
  setClientId({ commit }, clientId) {
    commit("SET_CLIENT_ID", clientId);
  },
  setCarlist({ commit }, carlist) {
    commit("SET_CARLIST", carlist);
  },
  setVer({ commit }, banben) {
    let localUserInfo = localStorage.getItem("userInfo") || "{}";
    commit("SET_USER_INFO", {
      ...JSON.parse(localUserInfo),
      ui_version: banben,
    });
    updateusers({ ui_version: banben });
  },
  logout({ commit }) {
    commit("RESET_STATE"); // 调用重置
  },
  initPermission({ commit }) {
    getPermission().then((response) => {
      const list = response.data;
      commit("SET_PERMISSION_LIST", list);
    });
  },
};
//  获取
const getters = {
  userInfo: (state) => state.userInfo,
  carlist: (state) => state.carlist,
  getClientId: (state) => state.clientId,
  isNw: (state) => state.isNw,
  getDRIVER_ENUM: (state) => state.DRIVER_ENUM,
  getCarlist: (state) => state.carlist,
  getRuleScore: (state) => state.answeringRules.rule_score,
  getHasNewRules: (state) => state.answeringRules.rule_switch,
  permissionList: (state) => state.permissionList,
  getVipInfo: (state) => {
    return {
      daysLeft: state.vip_daysLeft,
      expired: state.vip_expired,
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
